/* eslint-disable react/jsx-no-constructed-context-values */
import React, {
  createContext,
  useEffect,
  useState,
  useContext,
} from 'react';
import { NewsletterContextProps } from './NewsletterContext.types';
import { NewsletterProviderProps } from './NewsletterProvider.types';

const NewsletterContext = createContext<NewsletterContextProps>(undefined!);
export function useNewsletter() {
  return useContext(NewsletterContext);
}

const NEWSLETTER_POP_UP_TIMEOUT = 5000;

export function NewsletterProvider({ children }: NewsletterProviderProps) {
  const [newsletterAppBarOpen, setNewsletterAppBarOpen] = useState(false);
  const [email, setEmail] = useState<string | undefined>();
  const [popupDelay, setPopupDelay] = useState(NEWSLETTER_POP_UP_TIMEOUT);

  function closeNewsletterAppBar() {
    setNewsletterAppBarOpen(false);
  }

  useEffect(() => {
    setTimeout(() => {
      setNewsletterAppBarOpen(true);
    }, popupDelay);
  }, []);

  return (
    <NewsletterContext.Provider
      value={{
        email,
        newsletterAppBarOpen,
        closeNewsletterAppBar,
        setEmail,
        setPopupDelay,
      }}
    >
      {children}
    </NewsletterContext.Provider>
  );
}
